/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST + '/clb'
export const getClbAlipayFlowTable = params => {
  return axios.post(`${base}/query_alipay_flow`, params)
}
export const getClbAlipayFlowDetail = params => {
  return axios.get(`${base}/getClbAlipayFlowDetail/${params.id}`, {params})
}
export const exportClbAlipayFlowData = params => {
  return axios.get(`${base}/exportClbAlipayFlowData/${params.id}`, {params})
}
export const createClbAlipayFlowData = params => {
  return axios.post(`${base}/createClbAlipayFlowData`, params)
}
export const updateClbAlipayFlowData = params => {
  return axios.post(`${base}/updateClbAlipayFlowData/${params.id}`, params)
}
export const deleteClbAlipayFlowData = params => {
  return axios.post(`${base}/deleteClbAlipayFlowData/${params.id}`, params)
}



// WEBPACK FOOTER //
// ./src/views/clb-alipay-flow/clb-alipay-flow.api.js